// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import HotelClassificationBusinessListListResultModel from '../../model/hotel-classification-business-list-list-result-model';
import HotelClassificationBusinessListListResultDTO from '../dto/hotel-classification-business-list-list-result-dto';
import dtoSchema from '../schemas/hotel-classification-business-list-list-result-schema';
import HotelClassificationBusinessListModel from '../../model/hotel-classification-business-list-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class HotelClassificationBusinessListListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<HotelClassificationBusinessListListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => HotelClassificationBusinessListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: HotelClassificationBusinessListModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<HotelClassificationBusinessListListResultDTO>): HotelClassificationBusinessListListResultModel;
  static toModel(dto: DeepPartial<HotelClassificationBusinessListListResultDTO> | undefined | null): HotelClassificationBusinessListListResultModel | undefined;
  static toModel(dto: DeepPartial<HotelClassificationBusinessListListResultDTO> | undefined | null): HotelClassificationBusinessListListResultModel | undefined {
    return dto ? new HotelClassificationBusinessListListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<HotelClassificationBusinessListListResultModel> | HotelClassificationBusinessListListResultModel): HotelClassificationBusinessListListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as HotelClassificationBusinessListListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for HotelClassificationBusinessListListResultModel, can not map to HotelClassificationBusinessListListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
